import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import Alert from 'admin/components/common/Alert'
import PageFrame from 'admin/components/common/PageFrame'
import Text from 'admin/components/common/Text'
import {
  withContext,
  WithContextProps,
} from 'admin/components/common/withContext'
import { ConfigDestinationTypes, AlertLevels } from 'types'

const Error: React.FunctionComponent<
  ErrorProps & ErrorRouteProps & WithContextProps
> = (props) => {
 const {locations} = props.config
  const navigate = useNavigate()
  const { state } = useLocation()
  const alert =
    state && state.alert
      ? state.alert
      : {
          level: AlertLevels.ERROR,
          message: 'UNKNOWN_ERROR',
        }
  const destination =
    state && state.destination ? state.destination : locations.loginDestination
  const onClick = () => {
    switch (destination) {
      case ConfigDestinationTypes.HISTORY_BACK:
        navigate(-1)
        break
      default:
        navigate(destination)
        break
    }
  }
  return (
    <PageFrame>
      <div className="Box">
        <Alert alert={alert} className="l-margin--b" />
        <div className="l-align--center">
          <button onClick={onClick}>
            <Text>general.back</Text>
          </button>
        </div>
      </div>
    </PageFrame>
  )
}

type ErrorRouteProps = {}

type ErrorProps = {}

export default withContext(Error)

